module.exports = __webpack_public_path__ + "static/media/group-collapsed.6237def4.svg";